"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOccupationReportApiResponseSchema = exports.occupationReportItemSchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
const periodOfTheDaySchema = zod_1.z.enum(event_schema_1.periodsOfTheDay);
exports.occupationReportItemSchema = zod_1.z.object({
    date: zod_1.z.string(),
    period: periodOfTheDaySchema,
    simultaneousBookings: zod_1.z.number(),
    slots: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        doctorAttending: zod_1.z.object({
            id: zod_1.z.string(),
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
        }),
        doctorSubstitute: zod_1.z
            .object({
            id: zod_1.z.string(),
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
        })
            .nullable(),
    })),
});
exports.generateOccupationReportApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        office: zod_1.z.object({
            id: zod_1.z.string(),
            name: zod_1.z.string(),
        }),
        period: zod_1.z.object({
            from: zod_1.z.string().or(zod_1.z.date()),
            to: zod_1.z.string().or(zod_1.z.date()),
        }),
        errors: zod_1.z.array(exports.occupationReportItemSchema),
        warnings: zod_1.z.array(exports.occupationReportItemSchema),
    }),
});
